import { render, staticRenderFns } from "./FormPrecio.vue?vue&type=template&id=faf637de"
import script from "./FormPrecio.vue?vue&type=script&lang=js"
export * from "./FormPrecio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports